// Client-side mirror of analytics_api/tools_api/finance_rules.py. This only decides
// whether to SHOW the Finance tile; the analytics API enforces the same rule before
// serving any dashboard bytes, so hiding here is convenience, not security.
export const FINANCE_USER_SUBSTRINGS = ['luke', 'patrick', 'walker', 'riley'];

export const isFinanceUser = (profile) => {
    if (!profile) return false;
    const haystack = `${profile.name ?? ''} ${profile.email ?? ''} ${profile.preferred_username ?? ''}`.toLowerCase();
    return FINANCE_USER_SUBSTRINGS.some((s) => haystack.includes(s));
};
